import { PropsWithChildren } from 'react';

export default function FeatureBar({ children }: PropsWithChildren) {
  return (
    <div className="relative max-w-full w-full rounded-2xl backdrop-blur-md border-1 overflow-x-scroll">
      <div className="flex flex-row w-fit p-2 gap-2">{children}</div>
    </div>
  );
}
